const statusMap = {
  Available: {
    //   icon: <CheckCircle size={16} className="text-green-600" />,
    label: "Available",
  },
  "Not Available": {
    label: "No Connection",
  },
  Requested: {
    //   icon: <Hourglass size={16} className="text-yellow-600" />,
    label: "Requested",
  },
  Running: {
    //   icon: <Rocket size={16} className="text-blue-600" />,
    label: "Running",
  },
};

const AgentScanStatusBadge = ({ value: scanStatus, row }) => {
  // An offline agent can not be scanned, whatever the backend reports
  const isOffline = row?.original?.onlineStatus === false;
  const effectiveStatus =
    isOffline && scanStatus === "Available" ? "Not Available" : scanStatus;

  const normalizedStatus =
    effectiveStatus?.toLowerCase?.().replace(/\s+/g, "-") || "unknown";

  const data = statusMap[effectiveStatus] || {
    icon: null,
    label: effectiveStatus,
  };

  return (
    <div className={`scan-status-badge ${normalizedStatus ? normalizedStatus : "unknown"}`}>
      {data.icon}
      <span>{data.label}</span>
    </div>
  );
};

export default AgentScanStatusBadge;
